export default __webpack_public_path__ + "/assets/card_04-hover.png";